/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
//Standard libraries
import { takeLatest } from "redux-saga/effects";
//Redux
import * as WORKERS from "../workers/cadBasket";
import {
  CAD_BASKET_GET_REQUESTED_ACTION,
  CAD_BASKET_ADD_ITEM_REQUESTED_ACTION,
  CAD_BASKET_REMOVE_ITEM_REQUESTED_ACTION,
  CAD_BASKET_EMPTY_REQUESTED_ACTION,
  CAD_BASKET_ZIP_REQUESTED_ACTION,
} from "../../actions/cadBasket";

export function* watchSaga() {
  yield takeLatest(CAD_BASKET_GET_REQUESTED_ACTION, WORKERS.getCadBasket);
  yield takeLatest(CAD_BASKET_ADD_ITEM_REQUESTED_ACTION, WORKERS.addCadBasketItem);
  yield takeLatest(CAD_BASKET_REMOVE_ITEM_REQUESTED_ACTION, WORKERS.removeCadBasketItem);
  yield takeLatest(CAD_BASKET_EMPTY_REQUESTED_ACTION, WORKERS.emptyCadBasket);
  yield takeLatest(CAD_BASKET_ZIP_REQUESTED_ACTION, WORKERS.requestCadBasketZip);
}
